import {
  Address,
  AVAX,
  BASE,
  BCH,
  BSC,
  BTC,
  DOGE,
  ETH,
  GAIA,
  LTC,
  Msg,
  Network,
  Signer,
  Simulation,
  SOL,
  THOR,
  TON,
  TRON,
  TxResult,
  XRP,
} from "rujira.js";

let implementation: Promise<Signer> | null = null;

const CHAINS: Record<string, Network> = {
  Avalanche: AVAX,
  Base: BASE,
  BitcoinCash: BCH,
  BSC,
  Bitcoin: BTC,
  Dogecoin: DOGE,
  Ethereum: ETH,
  Cosmos: GAIA,
  Litecoin: LTC,
  Solana: SOL,
  THORChain: THOR,
  Ton: TON,
  Tron: TRON,
  Ripple: XRP,
};

const load = (): Promise<Signer> => {
  implementation ??= import("./vultisig/embedded").then(
    ({ default: signer }) => signer
  );
  return implementation;
};

/**
 * Lightweight proxy for the optional embedded Vultisig wallet.
 *
 * Importing the SDK eagerly pulls its large wallet-core WASM stack into every
 * browser startup, even for Keplr-only users. Keep the synchronous capability
 * surface here and load the real implementation only when Vultisig is used.
 */
const vultisig: Signer & { chains: () => Record<string, Network> } = {
  connect: async (): Promise<Address[]> => (await load()).connect(),
  simulate: async (msg: Msg): Promise<Simulation> =>
    (await load()).simulate(msg),
  signAndBroadcast: async (
    simulation: Simulation,
    msg: Msg
  ): Promise<TxResult> => (await load()).signAndBroadcast(simulation, msg),
  onChange: (callback) => {
    void load().then((signer) => signer.onChange?.(callback));
  },
  isAvailable: () => true,
  disconnect: () => {
    void load().then((signer) => signer.disconnect?.());
  },
  networks: (): Network[] => Object.values(CHAINS),
  chains: () => CHAINS,
};

export default vultisig;
